/** Design System Colors */
export type Color =
  | 'inherit'
  | 'red-light'
  | 'red-lighter'
  | 'blue'
  | 'blue-light'
  | 'red-light--blue'
  | 'light'
  | 'dark'
  | 'medium'
  | 'medium-light'
  | 'green';
export const colorList: Color[] = [
  'inherit',
  'red-light',
  'red-lighter',
  'blue',
  'blue-light',
  'red-light--blue',
  'light',
  'dark',
  'medium',
  'medium-light',
  'green',
];

/** Design System Color Schema */
export type ColorSchema = 'light' | 'dark' | 'dark-light';
export const COLOR_SCHEMA_LIGHT: ColorSchema = 'light';
export const COLOR_SCHEMA_DARK: ColorSchema = 'dark';
export const COLOR_SCHEMA_DARK_LIGHT: ColorSchema = 'dark-light';
export const colorSchemaList: ColorSchema[] = [COLOR_SCHEMA_LIGHT, COLOR_SCHEMA_DARK, COLOR_SCHEMA_DARK_LIGHT];
export const ColorSchemaToColor = (colorSchema: ColorSchema): Color => (colorSchema === 'light' ? 'blue' : 'light'); // FIXME: Workaround for <Text> component accepting COLOR only
// export const ColorSchemaToColor = (colorSchema: ColorSchema): Color => colorSchema as Color;

/** Design System Font Sizes */
export type FontSize =
  | '10'
  | '12'
  | '14'
  | '16'
  | '18'
  | '22'
  | '12--14'
  | '14--18'
  | '14--22'
  | '16--26'
  | '18--22'
  | '14--16'
  | '16--14'
  | '16--22'
  | '24--32'
  | '22--26'
  | '28--34'
  | '32--34';
export const fontSizeList: FontSize[] = [
  '10',
  '12',
  '14',
  '16',
  '18',
  '22',
  '12--14',
  '14--18',
  '14--22',
  '16--26',
  '18--22',
  '16--14',
  '14--16',
  '16--22',
  '24--32',
  '22--26',
  '28--34',
  '32--34',
];

/** Design System Font Weights */
export type FontWeight = '400' | '500' | '700' | '400--500';
export const fontWeightList: FontWeight[] = ['400', '500', '700', '400--500'];

// Design System Arrow Positions
export type IconPosition = 'left' | 'right';
export const ARROW_POSITION_LEFT: IconPosition = 'left';
export const ARROW_POSITION_RIGHT: IconPosition = 'right';
export const arrowPositionList: IconPosition[] = [ARROW_POSITION_LEFT, ARROW_POSITION_RIGHT];

// Design System Component sizes
export type ComponentSize =
  | 'xxxsmall'
  | 'xxsmall'
  | 'xsmall'
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'responsive'
  | 'dynamic';

export const COMPONENT_SIZE_XXXSMALL: ComponentSize = 'xxxsmall';
export const COMPONENT_SIZE_XXSMALL: ComponentSize = 'xxsmall';
export const COMPONENT_SIZE_XSMALL: ComponentSize = 'xsmall';
export const COMPONENT_SIZE_SMALL: ComponentSize = 'small';
export const COMPONENT_SIZE_MEDIUM: ComponentSize = 'medium';
export const COMPONENT_SIZE_LARGE: ComponentSize = 'large';
export const COMPONENT_SIZE_RESPONSIVE: ComponentSize = 'responsive';
export const COMPONENT_SIZE_DYNAMIC: ComponentSize = 'dynamic';
export const componentSizeList: ComponentSize[] = [
  COMPONENT_SIZE_XXXSMALL,
  COMPONENT_SIZE_XXSMALL,
  COMPONENT_SIZE_XSMALL,
  COMPONENT_SIZE_SMALL,
  COMPONENT_SIZE_MEDIUM,
  COMPONENT_SIZE_LARGE,
  COMPONENT_SIZE_RESPONSIVE,
  COMPONENT_SIZE_DYNAMIC,
];

export type Orientation = 'vertical' | 'horizontal';
export const ORIENTATION_VERTICAL: Orientation = 'vertical';
export const ORIENTATION_HORIZONTAL: Orientation = 'horizontal';
export const orientationsList: Orientation[] = [ORIENTATION_VERTICAL, ORIENTATION_HORIZONTAL];

export interface IDesignTokens {
  color?: Color;
  fontSize?: FontSize;
  fontWeight?: FontWeight;
}
